import { refreshTable } from '@packages/table-builder';
import { queryClient } from '@/queryClient';

export const SYSTEM_USERS_TABLE_ENTITY = 'system-user';

/** Infinite-scroll V2 table + legacy list cache (modals and row actions). */
export function refreshSystemUsersTable(registryRefresh?: () => void): void {
  registryRefresh?.();
  refreshTable(SYSTEM_USERS_TABLE_ENTITY);
  void queryClient.invalidateQueries('dt-v2-page');
  void queryClient.invalidateQueries('getAllCustomerUserList');
  void queryClient.invalidateQueries('getCustomerUserCustomerUserList');
}
